module.exports = __webpack_public_path__ + "media/audio47.95da8fca.mp3";